import { PureComponent } from "react";

import { type IOptionObject } from "./Option.js";

export interface IPlaceholderProps {
  placeholder: string;
  manySelectedPlaceholder: string;
  allSelectedPlaceholder: string;
  value: IOptionObject[];
  valueKey: string;
  labelKey: string;
  allSelected: boolean;
  numberDisplayed: number;
}

export default class Placeholder extends PureComponent<IPlaceholderProps> {
  public static defaultProps = {
    placeholder: "None selected",
    allSelectedPlaceholder: "All %d selected",
    manySelectedPlaceholder: "%d selected",
    allSelected: false,
    numberDisplayed: 1,
  };

  constructor(props: IPlaceholderProps) {
    super(props);
  }

  getNumberOfValues = (value: any[]): number => {
    if (value == null) {
      return 0;
    }
    if (!Array.isArray(value)) {
      throw new Error("Expected an array, found " + JSON.stringify(value));
    }
    return value.length;
  };

  formatPlaceholder = (placeholder: string, numberOfSelectedEntries: number): string => {
    if (placeholder.includes("%d")) {
      return placeholder.replace("%d", numberOfSelectedEntries.toString());
    }
    return placeholder;
  };

  getMessage = () => {
    const {
      placeholder,
      value,
      numberDisplayed,
      labelKey,
      manySelectedPlaceholder,
      allSelected,
      allSelectedPlaceholder,
    } = this.props;

    const numberOfEntries = this.getNumberOfValues(value);

    if (numberOfEntries === 0) {
      return placeholder;
    }

    if (numberOfEntries <= numberDisplayed) {
      return value.map((opt) => opt[labelKey]).join(", ");
    }

    if (!allSelected) {
      return this.formatPlaceholder(manySelectedPlaceholder, numberOfEntries);
    }

    return this.formatPlaceholder(allSelectedPlaceholder, numberOfEntries);
  };

  render() {
    const message = this.getMessage();

    return <span className="picky__placeholder">{message}</span>;
  }
}
